import type { AxiosRequestHeaders } from 'axios';
import { InternalHttpServiceRequestHeaders } from '../http.service';

const _shouldAppendContentfulBearerToken = (baseURL?: string) => {
  if (!baseURL) {
    return false;
  }

  return baseURL.startsWith(process.env.NEXT_PUBLIC_CONTENTFUL_BASE_URL as string);
};

export const contentfulBearerTokenInterceptor = (config: InternalHttpServiceRequestHeaders): InternalHttpServiceRequestHeaders => {
  if (_shouldAppendContentfulBearerToken(config?.baseURL)) {
    if (!config.headers) {
      (config.headers as Partial<AxiosRequestHeaders>) = {
        'Content-Type': 'application/json',
      };
    }
    config.headers.authorization = `Bearer ${process.env.NEXT_PUBLIC_CONTENTFUL_API_TOKEN}`;
  }

  return config;
};
